import { REMOVE_QUESTION } from '../actionTypes'

export const removeQuestion = (data: object) => ({
  type: REMOVE_QUESTION.name,
  api: {
    url: 'faq/remove',
    data,
  },
})
